<template>
  <tr v-if="product && product.data" v-bind:id="to_slug(product.data.code)">
    <td class="td_image">
      <p class="image">
        <!-- <img :src="image_link" v-show="is_load" @load="loaded"> -->
        <a :href="this.website_url" target="_blank">
          <img v-lazy="image_link">
        </a>
      </p>
    </td>
    <td class="td_info">
      <!-- <p>product</p> -->
      <p class="code"><a :href="this.website_url" class="link_code" target="_blank">{{product.data.code}}</a></p>
      <p class="name">{{product.data.name}}</p>
      <p class="price">
        <Price :product="this.product"/>
      </p>
      <p class="buttons">
        <a
          :href="this.catalogue_sheet_url"
          target="_blank"
          class="btn btn-outline-secondary btn-sm"
          :title="title_kk"
        >
          <i class="fa-regular fa-file-pdf"></i>
          <!-- <i class="fa fa-file-text" aria-hidden="true"></i> -->
        </a>
        <a
          :href="this.website_url"
          target="_blank"
          class="btn btn-outline-secondary btn-sm"
          :title="title_www"
        >
          <i aria-hidden="true">www</i>
          <!-- <i class="fa fa-globe" aria-hidden="true"></i> -->
        </a>
      </p>
    </td>
    <td class="td_parameters">
      <div class="basic" v-if="show_description">
        <p v-html="product.data.description"></p>
      </div>
      <button @click="set_show_params(true)" class="btn btn-outline-secondary btn-sm" v-if="!show_params">
        <i class="fa fa-th-list" aria-hidden="true"></i>
        {{ $t('message.show_parameters') }}
      </button>
      <Main :product_code="this.product.data.code" :product_id="this.product.product_id" v-if="show_params" @loaded="params_loaded()"></Main>
      <button
        @click="set_show_params(false)"
        class="btn btn-default pull-right"
        v-if="show_btn_hide_params"
      >
        <i class="fa fa-eye-slash" aria-hidden="true"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import Vue from "vue";
import Main from "./Params/Main.vue"
import Price from "./Product/Price.vue"
import { helpers } from "./mixins/helpers"
import { mapGetters } from "vuex";

export default {
  mixins: [helpers],
  components: {
    Main,
    Price
  },
  name: "Product",
  data() {
    return {
      imageLink: String,
      is_load: false,
      lang: "PL",
      show_params: false,
      params_is_loaded: false,
      title_www: '',
      title_kk: ''
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  mounted(){
      this.title_www = this.$i18n.messages[this.$i18n.locale].message.titleWWW
      this.title_kk = this.$i18n.messages[this.$i18n.locale].message.titleKK
  },
  methods: {
    loaded() {
      this.is_load = true
    },
    params_loaded() {
      this.params_is_loaded = true
    },
    set_show_params(show) {
      this.show_params = show
      if (false === show) {
        this.params_is_loaded = false
      }
    }
  },
  computed: {
    show_btn_show_params () {
      return !show_params;
    },
    show_btn_hide_params () {
      return this.show_params && this.params_is_loaded;
    },
    show_description () {
      return this.product.data.description && !this.show_params;
    },
    image_link () {
      return (
        // "https://www.pulsar.pl/img/produkty/" +
        // this.slash_to_comma(this.product.data.code) +
        // "_1.png"
        "https://lib.pulsar.pl/img/produkty/" +
        this.slash_to_comma(this.product.data.code) +
        "_1.png"
      );
    },
    catalogue_sheet_url () {
      return (
        // "https://www.pulsar.pl/" +
        // this.locale +
        // "/karta/" +
        // this.slash_to_comma(this.product.data.code) +
        // ".pdf"
        "https://lib.pulsar.pl/" +
        "karta/" +
        this.locale +
        "/" +
        this.slash_to_comma(this.product.data.code) +
        ".pdf"
      );
    },
    website_url () {
      return (
        "https://www.pulsar.pl/" +
        this.locale.toUpperCase() +
        "_9999_" +
        this.slash_to_double_comma(this.product.data.code) +
        "_"
      );
    },
    locale() {
      return this.$store.getters["pricelist/locale"];
    },
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
p {
  margin: 0;
}
tr {
  -webkit-transition: all 180ms ease;
  -moz-transition: all 180ms ease;
  -ms-transition: all 180ms ease;
  -o-transition: all 180ms ease;
  transition: all 180ms ease;
  width: 100%;
  td {
    display: block;
    // vertical-align: middle;
    text-align: center;
    border: 0 none;
    @media (min-width: 576px) {
      display: table-cell;
      border-top: 1px solid #dee2e6;
    }
    .description {
      font-size: 0.6em;
    }
    &.td_image {
      text-align: left;
      vertical-align: top;
      padding: 7.5px;
      width: 100%;
      @media (min-width: 576px) {
        width: 20%;
        padding: 30px 0;
      }
      .image {
        text-align: center;
        img {
          width: 50px;
          max-width: 100%;
          @media (min-width: 576px) {
            width: 100px;
            max-width: 100%;
          }
        }
      }
    }
    &.td_info {
      text-align: left;
      vertical-align: top;
      padding: 7.5px 0;
      @media (min-width: 576px) {
        padding: 30px 0;
      }
      .code {
        font-size: 0.8em;
        font-weight: 700;
        color: #5f5f5f;
        text-align: center;
        @media (min-width: 576px) {
          font-size: 0.9em;
          text-align: left;
        }
      }
      .name {
        font-size: 0.8em;
        color: #5f5f5f;
        text-align: center;
        @media (min-width: 576px) {
          font-size: 0.9em;
          text-align: left;
        }
      }
      .description {
        font-size: 0.6em;
        color: #5f5f5f;
      }
      .price {
        font-size: 0.8em;
        color: #5f5f5f;
        text-align: center;
        @media (min-width: 576px) {
          font-size: 0.9em;
          text-align: left;
        }
      }
      .buttons {
        text-align: center;
        @media (min-width: 576px) {
          text-align: left;
        }
      }
    }
  }
}
.td_parameters {
  position: relative;
  .basic {
    padding: 7.5px;
    font-size: 0.6em;
    text-align: left;
  }
}
.marked {
  -webkit-transition: all 540ms ease;
  -moz-transition: all 540ms ease;
  -ms-transition: all 540ms ease;
  -o-transition: all 540ms ease;
  transition: all 540ms ease;
  background: #f8f9a2 !important;
}
.link_code{
    color: #5f5f5f;
}
.link_code:hover{
    color: #000;text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Product.vue